// @flow

import _ from 'lodash';
import moment from 'moment';

import DateUtils from '../../utils/DateUtils';

import ApiObject from '../ApiObject';

export default class CreditCard extends ApiObject {

  /**
   *  Define the different types of credit cards.
   *  Support only Visa and mastercard due to API limitations
   */
  static Type = {

    /**
     * The card type does not exists or is not supported
     */
    UNKNOWN: 0,

    /**
     *  The visa.
     * A visa always begin by '4'.
     */
    VISA: 1,

    /**
     * The mastercard.
     * A mastercard always begin by '5'.
     */
    MASTERCARD: 2,

    /**
     * The american express.
     * Warning: The American express is not supported by the API.
     * An american express always begin by '3'.
     */
    AMEX: 3
  };

  id: string = '';

  /**
   * ISO_4217 format
   * @link https://www.wikiwand.com/en/ISO_4217
   */
  currency: string = 'EUR';

  number: string = '';

  expirationDate: Moment;

  name: string = '';

  cvv: string = '';

  postJsonAssignation(data: Object) {
    this.expirationDate = DateUtils.fromMsTimestamp(data.expirationDate);
  }

  toJSON() {
    const json = super.toJSON();

    if (!_.isNil(this.expirationDate)) {
      json.expirationDate = this.expirationDate.valueOf();
    }

    json.number = _.replace(json.number, /\s/g, '');

    return json;
  }

  getCleanNumber(): string {
    return _.replace(this.number, /\s/g, '');
  }

  getFormattedExpirationDate(): string {
    if (_.isNil(this.expirationDate) || !this.expirationDate.isValid()) {
      return 'N/A';
    }

    return this.expirationDate.format('MM/YYYY');
  }

  getShortFormattedExpirationDate(): string {
    if (_.isNil(this.expirationDate) || !this.expirationDate.isValid()) {
      return 'N/A';
    }

    return this.expirationDate.format('MM/YY');
  }

  //
  //
  //

  setExpirationYear(expirationYear: number) {
    if (_.isNil(this.expirationDate) || !this.expirationDate.isValid()) {
      this.expirationDate = moment(0);
    }
    this.expirationDate = this.expirationDate.year(expirationYear);
  }

  /**
   *
   * @expirationMonth the month index where january is 1 and december 12.
   * note that moment().month() months are zero indexed so january is 0 and december 11.
   */
  setExpirationMonth(expirationMonth: number) {
    if (_.isNil(this.expirationDate) || !this.expirationDate.isValid()) {
      this.expirationDate = moment(0);
    }
    // Accepts numbers from 0 to 11. If the range is exceeded, it will bubble up to the year.
    // Months are zero indexed, so January is month 0.
    this.expirationDate = this.expirationDate.month(expirationMonth - 1);
  }

  getExpirationMonth() {
    if (_.isNil(this.expirationDate) || !this.expirationDate.isValid()) {
      return (null);
    }
    return this.expirationDate.format('MM');
  }

  getExpirationYear() {
    if (_.isNil(this.expirationDate) || !this.expirationDate.isValid()) {
      return (null);
    }
    return this.expirationDate.format('YYYY');
  }

  //
  //
  //

  getType() {
    if (_.isEmpty(this.number)) {
      return CreditCard.Type.UNKNOWN;
    }

    switch (this.number[0]) {
      case '3':
        return  CreditCard.Type.AMEX;
      case '4':
        return CreditCard.Type.VISA;
      case '5':
        return CreditCard.Type.MASTERCARD;
      default:
        return CreditCard.Type.UNKNOWN;
    }
  }
}



// WEBPACK FOOTER //
// ./sdk/scripts/entities/user/CreditCard.js